import { GetterTree } from 'vuex';
import { DashboardState, DashboardCommentRemindersPaginator } from './types';
import { RootState } from '@/types';
import { User } from '../authentication/types';

export const getters: GetterTree<DashboardState, RootState> = {
    reminders(state): DashboardCommentRemindersPaginator | undefined {
        const reminders  = state.data.reminders || undefined;
        return reminders;
    },
    users(state): User[] | undefined {
        const users  = state.data.users || undefined;
        return users;
    },
    remindersLoading(state): boolean {
        const loading  = state.remindersLoading || false;
        return loading;
    },
};
